import produce from 'immer';

import { PriorityValueChangeAction } from '../../actions/internalGroups/changePriorityValue';
import { parseNumber } from '../../service/FormatHelpers/FormatHelpers';
import { ValidationErrorsData } from '../../typings/common';
import { EditGroupsState, EditInternalGroupDataValue } from '../../typings/groupsEditState';

const getGroupsErrorsWithoutCurrentListErrors = (
    errors: ValidationErrorsData,
    currentListErrors: Array<string>
): ValidationErrorsData => {
    return Object.keys(errors).reduce((acc, errorKey) => {
        if (!currentListErrors.includes(errorKey)) {
            acc[errorKey] = errors[errorKey];
        }
        return acc;
    }, {});
};

export const changePriorityValue = (state: EditGroupsState, action: PriorityValueChangeAction): EditGroupsState => {
    const { groupId, value } = action;
    const { errors } = state.groups[groupId];
    const validLevel = parseNumber(value);

    if (validLevel > Number.MAX_SAFE_INTEGER || !Number.isInteger(validLevel)) {
        return state;
    }

    const newLevel = value === '' ? undefined : validLevel.toString();
    return produce(state, draft => {
        (draft.groups[groupId].value as EditInternalGroupDataValue).level = newLevel;
        draft.groups[groupId].errors = getGroupsErrorsWithoutCurrentListErrors(errors, ['level']);
    });
};
